//apifetch
import axios from "axios";

//translate
import i18n from "../../translate/i18n";

//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;


export const GetHomeRoom = async () => {
    const response = await axios.get(`${baseURL}/rooms/one-per-category`, {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": i18n.language,
      },
    });
    return response.data;
}